<div id="dark" style="padding-top:120px; min-height: 100vh;">
  <div class="settings dark-bb">
    <div class="container-fluid">
      <h4 class="text-color-theme mb-4" style="text-align: start;">{{"trading-history"|translate}}</h4>
      <div class="row">
        <div class="col-md-12 col-lg-2">
          <div class="nav flex-column nav-pills settings-nav" id="v-pills-tab" role="tablist"
            aria-orientation="vertical">
            <a class="nav-link active" id="orders-tab" data-toggle="pill" href="#orders" role="tab"
              aria-controls="orders" aria-selected="true">
              <i class="icon ion-md-information-circle px-2"></i> {{"orders"|translate}}</a>
            <a class="nav-link" id="trades-tab" data-toggle="pill" href="#trades" role="tab" aria-controls="orders">
              <i class="icon ion-md-information-circle px-2"></i> {{"trades"|translate}}</a>
          </div>
        </div>
        <div class="col-md-12 col-lg-10 mt-xl-0 mt-lg-0 mt-4">
          <div class="tab-content" id="v-pills-tabContent">

            <div class="tab-pane fade show active" id="orders" role="tabpanel" aria-labelledby="trades-tab">
              <div class="card settings-profile">
                <div class="card-body">
                  <form [formGroup]="orderRequestFormGroup">
                    <div class="mb-4">
                      <h3 class="text-color-theme" style="text-align: start;">{{"order-history-details"|translate}}</h3>
                    </div>
                    <!-- <h6 class="text-muted mb-4" style="text-align: start;">{{"order-history-details"|translate}}</h6> -->
                    <div class="row m-1 mb-3 custom-sm-gap">
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <!-- <select style="min-width: 150px;" class="form-select px-2 primary form-select-sm" [(ngModel)]="selectedAccount" formControlName="relationCode">
                          <option *ngFor=" let acc of accList" value="{{acc.relationCode}}">({{acc.relationCode}}) {{(translate.currentLang=="en")?acc.clientNameEn:acc.clientNameAr}}</option>
                        </select> -->
                        <ng-select class="custom" appearance="outline" [clearable]="false"
                          formControlName="relationCode" [(ngModel)]="selectedAccount" [searchable]="false">
                          <ng-option *ngFor="let acc of accList" value="{{acc.relationCode}}">
                            ({{acc.relationCode}})
                            {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12 my-xl-0 my-lg-0 my-md-0 my-sm-0 my-xs-2">
                        <mat-form-field appearance="fill">
                          <mat-label class="mx-2">{{"date" | translate}}</mat-label>
                          <mat-date-range-input [rangePicker]="datepicker" [max]="today">
                            <input matStartDate formControlName="fromDate" placeholder="Start date">
                            <input matEndDate formControlName="toDate" placeholder="End date">
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="datepicker"
                            (click)="onOpen(1)"></mat-datepicker-toggle>
                          <mat-date-range-picker #datepicker></mat-date-range-picker>

                          <mat-error
                            *ngIf="orderRequestFormGroup.controls.fromDate.hasError('matStartDateInvalid')">Invalid
                            start date</mat-error>
                          <mat-error *ngIf="orderRequestFormGroup.controls.toDate.hasError('matEndDateInvalid')">Invalid
                            end date</mat-error>
                        </mat-form-field>
                        <div style="display: none">
                          <div class="datepicker-footer" #datepickerFooter>
                            <button mat-raised-button color="primary" (click)="orderPrevDate(0)">
                              {{'today'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="orderPrevDate(1)">
                              {{'yesterday'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="orderPrevDate(7)">
                              {{'week'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="orderPrevDate(30)">
                              {{'month'|translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row settings-notification">
                      <div class="col-md-3 text-color-theme">
                        <div class="mb-3">
                          <h6>{{"symbolCode"|translate}}</h6>
                          <div class="autocomplete">
                            <div class="search-bar input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" id="inputGroup-sizing-sm" style="border-radius: 2px;"><i
                                    class="icon ion-md-search icon-search-color"></i></span>
                              </div>
                              <input type="text" class="form-control" placeholder="{{'search'|translate}}"
                                [ngModel]="this.symbolCodeName" (keyup)="credentialsSearchFilter($event)"
                                [ngModelOptions]="{standalone: true}">
                              <button class="clearButton" *ngIf="this.symbolCodeName" matSuffix mat-icon-button
                                aria-label="Clear" (click)="xButton()">
                                <mat-icon>close</mat-icon>
                              </button>
                            </div>

                            <div *ngIf="searchSubmit " class="suggestion-list">
                              <div *ngFor="let record of records " (click)="selectedOrderRecored(record)"
                                class="d-flex justify-content-between search-result-div">
                                <div
                                  style="cursor:pointer;padding-inline-end: 10px;padding-inline-start: 10px;white-space: nowrap;overflow: hidden;align-self:center;vertical-align:middle; text-align: start;">
                                  {{(translate.currentLang=='en')?record.SymbolNameE:record.SymbolNameA}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-2">
                          <h6 class="text-color-theme">{{"status"|translate}}</h6>
                          <ng-select [clearable]="false" [searchable]="false" class="custom" appearance="outline"
                            formControlName="fixStatus">
                            <ng-option value="">{{'all'|translate}}</ng-option>
                            <ng-option class="text-color-theme" *ngFor="let status of statusFilter" value="{{status.Value}}">
                              {{(translate.currentLang=="en")?status.NameE:status.NameA}}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-2 text-color-theme">
                        <div class="mb-3">
                          <h6>{{"type"|translate}}</h6>
                          <ng-select [clearable]="false" [searchable]="false" class="custom" appearance="outline"
                            formControlName="transactionType">
                            <ng-option value="">{{'all'|translate}}</ng-option>
                            <ng-option class="text-color-theme" *ngFor="let type of typeFilter"
                              value="{{type.TransactionId}}">
                              {{(translate.currentLang=="en")?type.TransactionNameE:type.TransactionTypeA}}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-2 text-color-theme">
                        <div class="mb-3">
                          <h6>{{"market"|translate}}</h6>
                          <ng-select [clearable]="false" [searchable]="false" class="custom" appearance="outline"
                            formControlName="transactionType">
                            <ng-option value="">{{'all'|translate}}</ng-option>
                            <ng-option class="text-color-theme" *ngFor="let market of marketFilter"
                              value="{{market.MarketID}}">
                              {{(translate.currentLang=="en")?market.MarketNameE:market.MarketNameA}}
                            </ng-option>
                          </ng-select>
                          <!-- <select id="market" name="market" class="custom-select" formControlName="marketId">
                            <option value="">{{'all'|translate}}</option>
                            <option *ngFor="let market of marketFilter" value="{{market.MarketID}}">{{(translate.currentLang=="en")?market.MarketNameE:market.MarketNameA}}</option>
                          </select> -->
                        </div>
                      </div>
                      <div class="col-md-2 align-self-center">
                        <button class="btn btn-search btn-primary mt-2" [disabled]="orderRequestFormGroup.invalid"
                          (click)="fetchOrders()">
                          {{'search'|translate}}
                        </button>
                      </div>

                    </div>
                  </form>
                </div>

                <div class="card settings-profile">
                  <div style="height: 400px;">
                    <app-trades-order-history [orderRequest]="this.userOrders" [statusList]="this.statusFilter"
                      [typesList]="this.typeFilter"></app-trades-order-history>
                  </div>
                </div>
              </div>


            </div>
            <div class="tab-pane fade" id="trades" role="tabpanel" aria-labelledby="trades-tab">
              <div class="card settings-profile">
                <div class="card-body">
                  <form [formGroup]="transactionRequestFormGroup">
                    <div class="mb-4">
                      <h3 class="text-color-theme" style="text-align: start;">{{"trading-history-details"|translate}}</h3>
                    </div>
                    <!-- <h6 class="text-muted mb-4" style="text-align: start;">{{"order-history-details"|translate}}</h6> -->
                    <div class="row m-1 mb-3 custom-sm-gap">
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                        <!-- <select style="min-width: 150px;" class="form-select px-2 primary form-select-sm" [(ngModel)]="selectedAccount" formControlName="relationCode">
                          <option *ngFor=" let acc of accList" value="{{acc.relationCode}}">({{acc.relationCode}}) {{(translate.currentLang=="en")?acc.clientNameEn:acc.clientNameAr}}</option>
                        </select> -->
                        <ng-select class="custom" appearance="outline" [clearable]="false"
                          formControlName="relationCode" [(ngModel)]="selectedAccount" [searchable]="false">
                          <ng-option *ngFor="let acc of accList" value="{{acc.relationCode}}">
                            ({{acc.relationCode}})
                            {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 my-xl-0 my-lg-0 my-md-0 my-sm-0 my-xs-2">
                        <mat-form-field appearance="fill">
                          <mat-label class="mx-2">{{"date" | translate}}</mat-label>
                          <mat-date-range-input [rangePicker]="datepicker2" [max]="today">
                            <input matStartDate formControlName="fromDate" placeholder="Start date">
                            <input matEndDate formControlName="toDate" placeholder="End date">
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="datepicker2"
                            (click)="onOpen(2)"></mat-datepicker-toggle>
                          <mat-date-range-picker #datepicker2></mat-date-range-picker>

                          <mat-error
                            *ngIf="transactionRequestFormGroup.controls.fromDate.hasError('matStartDateInvalid')">Invalid
                            start date</mat-error>
                          <mat-error
                            *ngIf="transactionRequestFormGroup.controls.toDate.hasError('matEndDateInvalid')">Invalid
                            end date</mat-error>
                        </mat-form-field>
                        <!-- Workaround for adding the buttons -->
                        <div style="display: none">
                          <div class="datepicker-footer" #datepickerFooter2>
                            <button mat-raised-button color="primary" (click)="PrevDate(0)">
                              {{'today'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="PrevDate(1)">
                              {{'yesterday'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="PrevDate(7)">
                              {{'week'|translate}}
                            </button>
                            <button mat-raised-button color="primary" (click)="PrevDate(30)">
                              {{'month'|translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row settings-notification">
                      <div class="col-md-4 text-color-theme">
                        <div class="mb-3">
                          <h6>{{"symbolCode"|translate}}</h6>
                          <div class="autocomplete">
                            <div class="search-bar">
                              <div class="search-bar input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" id="inputGroup-sizing-sm"
                                    style="border-radius: 2px;"><i class="icon ion-md-search icon-search-color"></i></span>
                                </div>
                                <input type="text" class="form-control" placeholder="{{'search'|translate}}"
                                  [ngModelOptions]="{standalone: true}" [ngModel]="this.symbolCodeName"
                                  (keyup)="credentialsSearchFilter($event)">
                                <button class="clearButton" *ngIf="this.symbolCodeName" matSuffix mat-icon-button
                                  aria-label="Clear" (click)="xButton()">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            </div>
                            <div *ngIf="searchSubmit" class="suggestion-list">
                              <div *ngFor="let record of records"
                                class="d-flex justify-content-between search-result-div">
                                <div (click)="selectedTransactionRecored(record)"
                                  style="cursor:pointer;padding-inline-end: 10px;padding-inline-start: 10px;white-space: nowrap;overflow: hidden;align-self:center;vertical-align:middle; text-align: start;">
                                  {{(translate.currentLang=='en')?record.SymbolNameE:record.SymbolNameA}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3 text-color-theme">
                        <div class="mb-3">
                          <h6>{{"type"|translate}}</h6>
                          <ng-select [clearable]="false" [searchable]="false" class="custom"
                            formControlName="transactionType">
                            <ng-option value="">{{'all'|translate}}</ng-option>
                            <ng-option *ngFor="let type of typeFilter"
                              value="{{type.TransactionId}}">{{(translate.currentLang=="en")?type.TransactionNameE:type.TransactionTypeA}}</ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-2 align-self-center">
                        <button class="btn btn-search btn-primary mt-2" [disabled]="transactionRequestFormGroup.invalid"
                          (click)="fetchTrades()">
                          {{'search'|translate}}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="card settings-profile">
                  <div style="height: 400px;">
                    <app-order-history [orderRequest]="this.userTransactions" [typesList]="this.typeFilter"
                      [symbolList]="this.stocksFilter"></app-order-history>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>